import type { ApiChild, ApiChildSession, Child, ChildGroup, ChildLocation } from '../types';

const UNKNOWN_LOCATION: ChildLocation = { id: '', name: 'Onbekende locatie' };
const UNKNOWN_GROUP: ChildGroup = { id: '', name: 'Onbekende groep' };

const time = (date: string): number => new Date(date).getTime();

const isActive = (sessions: ReadonlyArray<ApiChildSession>, now: number): boolean =>
  sessions.some((session: ApiChildSession): boolean => time(session.to) >= now);

const toDistinctLocations = (
  sessions: ReadonlyArray<ApiChildSession>,
  fallback: ChildLocation,
): ReadonlyArray<ChildLocation> => {
  const seen: Set<string> = new Set<string>();
  const locations: ChildLocation[] = [];
  for (const session of sessions) {
    const location: ChildLocation = { id: session.group.location.id, name: session.group.location.name };
    if (!seen.has(location.id)) {
      seen.add(location.id);
      locations.push(location);
    }
  }
  return locations.length > 0 ? locations : [fallback];
};

const toDistinctGroups = (
  sessions: ReadonlyArray<ApiChildSession>,
  fallback: ChildGroup,
): ReadonlyArray<ChildGroup> => {
  const seen: Set<string> = new Set<string>();
  const groups: ChildGroup[] = [];
  for (const session of sessions) {
    const group: ChildGroup = { id: session.group.id, name: session.group.name };
    if (!seen.has(group.id)) {
      seen.add(group.id);
      groups.push(group);
    }
  }
  return groups.length > 0 ? groups : [fallback];
};

export const toChildBase = (api: ApiChild, now: number): Omit<Child, 'development' | 'notes' | 'observations'> => ({
  id: api.id,
  name: api.fullName,
  status: isActive(api.sessions, now) ? 'active' : 'ended',
  hidden: api.hidden,
  locations: toDistinctLocations(api.sessions, UNKNOWN_LOCATION),
  groups: toDistinctGroups(api.sessions, UNKNOWN_GROUP),
  dateOfBirth: api.dateOfBirth,
});
